import React from 'react';

function SingleArmAnestheticPandant() {
  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    padding: '16px',
    backgroundColor: '#fff',
  };

  const imageStyle = {
    maxWidth: '90%',
    height: 'auto',
    objectFit: 'contain',
    borderRadius: '12px',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
  };

  return (
    <div style={containerStyle}>
      <img
        src="/od5.png"
        alt="Single Arm Anesthetic Pendant"
        style={imageStyle}
      />
    </div>
  );
}

export default SingleArmAnestheticPandant;
